import { createRoot } from 'react-dom/client';
import { StrictMode } from 'react';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { BrowserRouter, Route, Routes } from 'react-router';
import "./App.css";
import { NoSuchPage } from './NoSuchPage';
import Template from './Template';

let container = document.getElementById("app")!;
let root = createRoot(container)
root.render(
  <StrictMode>
    <FluentProvider theme={webLightTheme}>
      <BrowserRouter>
        <Routes>
          <Route element={<Template />}>
            <Route path="*" element={<NoSuchPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </FluentProvider>
  </StrictMode>
);
